/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Typography, Box } from '@material-ui/core';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import useStyles from './styles';
import Bar from '../Charts/Bar';
import Donut from '../Charts/Donut';
import Search from '../Search/Search';

import TranslationTxt from '../TranslationTxt/TranslationTxt';

import languagify from '../../../utils/languagify';

const BarDonutSection = ({ header, text }) => {
  const [toggle, setToggle] = useState('race');

  const handleToggle = (event, newToggle) => {
    setToggle(newToggle);
  };

  const measures = [
    'Supervisor',
    'Full-time',
    'Part-time',
    'Interns',
  ];

  const classes = useStyles();
  return (
    <div className="section" style={{ marginBottom: 50, marginTop: 80 }}>
      <Typography variant="h3" className={classes.header}>
        <TranslationTxt measure={header} />
      </Typography>
      <Typography variant="body1" className={classes.text}>
        <TranslationTxt measure={text} />
      </Typography>

      <Box className={classes.filter}>
        <Box className={classes.filterBy}>
          <Typography variant="body1" className={classes.toggleText}>
            <TranslationTxt measure="=Only({<Index = {21}>}[$(vLanguage)])" />
          </Typography>
          <ToggleButtonGroup
            value={toggle}
            exclusive
            onChange={handleToggle}
            aria-label="filter by"
            className={classes.toggles}
          >
            <ToggleButton value="race" aria-label="race" className={classes.toggleItem}>
              <Typography variant="body1" className={classes.toggleLabel}>
                <TranslationTxt measure="=Only({<Index = {22}>}[$(vLanguage)])" />
              </Typography>
            </ToggleButton>

            <ToggleButton value="gender" aria-label="gender" className={classes.toggleItem}>
              <Typography variant="body1" className={classes.toggleLabel}>
                <TranslationTxt measure="=Only({<Index = {23}>}[$(vLanguage)])" />
              </Typography>
            </ToggleButton>

          </ToggleButtonGroup>
        </Box>
        <Search footnote dimension="[Name of media outlet for search - 2023]" />
      </Box>

      <Box className={classes.chartsWrapper}>
        {
          toggle === 'gender' ? (
            <Box className={classes.legend}>
              <Typography className={clsx(classes.legendLabel, classes.legendWomen)}>
                <TranslationTxt measure="=Only({<Index = {9}>}[$(vLanguage)])" />
              </Typography>
              <Typography className={clsx(classes.legendLabel, classes.legendMen)}>
                <TranslationTxt measure="=Only({<Index = {10}>}[$(vLanguage)])" />
              </Typography>
              <Typography className={clsx(classes.legendLabel, classes.legendNonBinary)}>
                <TranslationTxt measure="=Only({<Index = {11}>}[$(vLanguage)])" />
              </Typography>
            </Box>
          ) : ''
        }
        <Box className={classes.chartsContainer}>
          {
            measures.map((m) => (
              <Box className={clsx({ [classes.chart]: true, [classes.donutChart]: toggle === 'gender' })} key={m}>
                {toggle === 'race' ? (
                  <Box className={classes.bar}>
                    <Typography variant="body2" className={classes.chartTitle}>{m === 'Full-time' ? languagify('Full-time (No Supervisors)') : (m === 'Supervisor' ? languagify('Supervisors') : languagify(m))}</Typography>
                    <Bar measure={m} />
                  </Box>
                ) : (
                  <Box className={classes.donut}>
                    <Typography variant="body2" className={classes.chartTitle}>{m === 'Supervisor' ? languagify('Supervisors') : languagify(m)}</Typography>
                    <Donut measure={m} />
                  </Box>
                )}
              </Box>
            ))
          }
        </Box>
      </Box>
    </div>
  );
};

BarDonutSection.propTypes = {
  header: PropTypes.string,
  text: PropTypes.string,
};

BarDonutSection.defaultProps = {
  header: '',
  text: '',
};

export default BarDonutSection;
